<template>
  <div>
    <img :src="logo" width="38"/>
    <img v-if="newYear"
         :src="logoNewYear"
         width="42"
         style="transform: rotateZ(18deg);left:20px;top:-1px"
         class="position-absolute"
    />
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: ['height'],
  data:()=>({
    logo: require('@/assets/mediana-logo-small-white.svg'),
    logoNewYear: require('@/assets/new-year-cap.svg'),
    newYear:false,
  }),
  mounted() {
    const m = moment();
    const month = m.month();
    const day = m.date();
    if((month === 11 && day >= 20) || (month === 0 && day <= 10))
      this.newYear = true;
  }
}
</script>
